import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/profesional/membresia.css';
import * as globals from './../../components/GlobalScripts.js';
import Sidebar_left from './Sidebar_left';
import { Link } from 'react-router-dom';

const Profesional_MetodoDePago = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);
    const [step, setStep] = useState(1);
    const [formDataMembership, setFormDataMembership] = useState({});
    const [niveles, setNiveles] = useState([]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
            
            if (userParsed.membership) {
                setFormDataMembership(userParsed.membership);
            }
        }

        get_niveles();
    }, []);

    const get_niveles = () => {
        axios.post(`${path_api}/default/niveles.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setNiveles(response.data.niveles);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los niveles",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar niveles",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleSubmit_Membership = async (e) => {
        e.preventDefault();
        if (formDataMembership.id > user?.nivel)
            chargeStripe();
        else
            updateMembership();
    };

    const handleChange_Membership = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataMembership({ ...formDataMembership, [name]: newValue });
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            initializeStripe();
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initializeStripe = async () => {
        await axios
            .post(`${path_api}/get_stripe_keys.php`, {
                rute: globals.getRuteBackend()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    if (!window.stripe)
                        window.stripe = window.Stripe(response.data.key_public);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
    };

    const chargeStripe = async () => {
        globals.openViewCharge();
        await axios
            .post(`${path_api}/stripe/create.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                membership: niveles[formDataMembership.id]
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {
                    setStep(2);
                    const intervalId = setInterval(async () => {
                        const paymentElement = document.querySelector('#payment-element');
                        if (paymentElement) {
                            window.clientSecret = response.data.response.client_secret;

                            window.elements = window.stripe.elements({ clientSecret: window.clientSecret });

                            await window.elements.create("payment", { layout: "tabs" }).mount("#payment-element");

                            globals.closeViewCharge();

                            clearInterval(intervalId);
                        }
                    }, 1000);

                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    globals.closeViewCharge();
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    const updateMembership = async () => {
        globals.openViewCharge();
        await axios
            .post(`${path_api}/update-account/membership.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                membership: niveles[formDataMembership.id]
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {
                    globals.createAlert({
                        type: "success",
                        msg_title: "Éxito",
                        msg: "La membresia se actualizo con exito.",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000
                    });
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    setUser(response.data.user);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Error al actualizar tu membresia",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error al conectar con el servidor'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            }).finally(() => {
                globals.closeViewCharge();
            });
    };

    const handleSubmit_Stripe = async (e) => {
        e.preventDefault();
        globals.openViewCharge();

        let redirect = globals.getRuteTY_membership();
        let url = `https://donhonesto.zadrig.com/backend/stripe/confirm/?redirect=${encodeURIComponent(redirect)}&new_lvl=${formDataMembership.id}&new_membership=${niveles[formDataMembership.id].descripcion}`;
        await window.stripe.confirmPayment({
            elements: window.elements,
            confirmParams: {
                return_url: url,
            },
        }).then(function (result) {
            if (result.error) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: result.error.message, effect: "opacidad 2s, desplazamiento 2s", time_life: 6000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Error interno, intenta más tarde", effect: "opacidad 2s, desplazamiento 2s", time_life: 8000 });
            }
            globals.closeViewCharge();
        });
    };

    const formatTime = (timeInMinutes) => {
        const days = Math.floor(timeInMinutes / 1440);
        const hours = Math.floor((timeInMinutes % 1440) / 60);
        const minutes = timeInMinutes % 60;
        return `${days} dias, ${hours} horas y ${minutes} minutos`;
    };      

    return (
        <>
            <div className='container-profesional page-membresia container-section'>
                <div className='left-side'>
                    <Sidebar_left />
                </div>
                <div className="right-side">
                    {step == 1 && (
                        <form onSubmit={handleSubmit_Membership} className="flex-column gap-20">
                            <div className='sticky-form'>
                                <button className="button-primary" type="submit">Actualizar</button>
                            </div>
                            <h2>Membresia</h2>

                            <div className="form-grop-row">
                                <div className="form-group">
                                    <label htmlFor="id">Nivel</label>
                                    <select
                                        id="id"
                                        name="id"
                                        value={formDataMembership.id}
                                        onChange={handleChange_Membership}
                                        className="input-primary"
                                        required
                                    >
                                        {niveles.map((nivel, index) => (
                                            <option key={index} value={nivel.id}>
                                                {nivel.descripcion}
                                            </option>
                                        ))}
                                    </select>
                                    {formDataMembership.id == user?.membership?.id && user?.membership?.membership_renewal?.time && (
                                        <p>Renovación automatica en {formatTime(user.membership.membership_renewal.time)}</p>
                                    )}

                                </div>

                                <div className="form-group">
                                    <label>Beneficios: <p>{niveles[formDataMembership.id]?.beneficios}</p></label>
                                    <label>Precio: <p>{niveles[formDataMembership.id]?.precio > 0 ? '$' + niveles[formDataMembership.id]?.precio + ' MXN/30 dias' : "Gratis"}</p></label>
                                </div>
                            </div>
                            {formDataMembership.id > user?.nivel && (
                                <div className="form-group">
                                    <p>Al actualizar a un nivel superior se le realizará un cobro del total mensual.</p>
                                    <p className='text-green'>Obtendrás de inmediato los beneficios de tu nueva membresia.</p>
                                </div>
                            )}
                            {formDataMembership.id < user?.nivel && (
                                <div className="form-group">
                                    <p>Al actualizar a un nivel inferior no se le realizará ningún cobro por el cambio.</p>
                                    <p className='text-red'>Perderás de inmediato los beneficios de tu membresia actual.</p>
                                </div>
                            )}
                        </form>
                    )}

                    {step == 2 && (
                        <form onSubmit={handleSubmit_Stripe} className="flex-column gap-20">
                            <h2>Pago de membresia</h2>
                            <div id="stripe-container">
                                <div id="payment-element"></div>
                            </div>
                            <button type="submit" className="button-primary green">Finalizar pago</button>
                        </form>
                    )}
                </div>
            </div>
        </>
    );
};

export default Profesional_MetodoDePago;
